<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="商品名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.productName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div class="selectBox">
          <span class="selectText">是否上架</span>
          <el-select v-model="queryParam.isShow" size="mini" placeholder="请选择">
            <el-option label="请选择" value></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button size="mini" type="primary" @click="handleAdd()"
            >新增</el-button
          >
          <el-popconfirm
            style="margin-left: 10px"
            title="确定上架吗？"
            @confirm="grounding(1)"
          >
            <template #reference>
              <el-button size="mini" type="success"
                >上架</el-button
              >
            </template>
          </el-popconfirm>
          <el-popconfirm
            style="margin-left: 10px"
            title="确定下架吗？"
            @confirm="grounding(0)"
          >
            <template #reference>
              <el-button size="mini" type="warning">下架</el-button>
            </template>
          </el-popconfirm>
          <el-popconfirm
            style="margin-left: 10px"
            title="确定删除吗？"
            @confirm="handleDelete()"
          >
            <template #reference>
              <el-button size="mini" type="danger">删除</el-button>
            </template>
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #isShow="slotData">
        <p v-if="slotData.data.row.isShow == 1">是</p>
        <p v-if="slotData.data.row.isShow == 0">否</p>
      </template>
      <template #photo="slotData">
        <el-image
          v-if="slotData.data.row.productImage"
          style="width: 100px; height: 50px"
          :src="slotData.data.row.productImage"
          :preview-src-list="[slotData.data.row.productImage]"
          :key="slotData.data.row.id"
        >
          <div
            slot="error"
            class="image-slot"
            style="width: 100px; height: 50px"
          >
            <img
              src="@/assets/imgFail.png"
              alt
              style="width: 60px; height: 40px"
            />
          </div>
        </el-image>
        <span style="color: gray" v-else>暂无</span>
      </template>
      <template #isHot="slotData">
        <p v-if="slotData.data.row.isHot == 1">是</p>
        <p v-if="slotData.data.row.isHot == 0">否</p>
      </template>
      <template #isNew="slotData">
        <p v-if="slotData.data.row.isNew == 1">是</p>
        <p v-if="slotData.data.row.isNew == 0">否</p>
      </template>
      <template #handlerSlot="slotData">
        <el-button size="mini" @click="handleEdit(slotData.data.row)"
          >修改</el-button
        >
        <el-button
          size="mini"
          type="success"
          @click="handleDetail(slotData.data.row, true)"
          >详情</el-button
        >
      </template>
    </e-table>
    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
import modalForm from "./component/userModal";

import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  components: { eTable, modalForm },
  mixins: [listMixin],
  props: {},
  data() {
    return {
      deleteKey: "userId",
      url: {
        list: "/mallProduct/queryPage",
        delete: "/mallProduct/delProduct",
        productIsShow: "/mallProduct/productIsShow",
      },

      //字段权限
      columns: [
        // { field: 'code', label: '角色编码' },
        {
          field: "productName",
          label: "商品名称",
        },
        {
          field: "productOriginalPrice",
          label: "原价",
          width: 100,
        },
        {
          field: "productPrice",
          label: "价格",
          width: 100,
        },
        {
          field: "stock",
          label: "库存",
          width: 100,
        },

        {
          field: "isShow",
          label: "是否上架",
          width: 100,
          slotName: "isShow",
          columnType: "slot",
        },
        {
          field: "isNew",
          label: "是否新品",
          width: 100,
          slotName: "isNew",
          columnType: "slot",
        },
        {
          field: "isHot",
          label: "是否热门",
          width: 100,
          slotName: "isHot",
          columnType: "slot",
        },
        {
          width: 200,
          label: "商品图片",
          slotName: "photo",
          columnType: "slot",
        },
        { field: "description", label: "商品描述" },

        // { field: 'createDate', label: '创建时间' },

        // { field: 'createName', label: '创建人' },

        {
          width: 160,
          label: "编辑",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
    grounding(type) {
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        let arr = [];
        this.selectedRowKeys.forEach((item) => {
          arr.push({ id: item, isShow: type });
        });
        httpAction(this.url.productIsShow, arr, "post").then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.loadData(1);
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$message.warning("请选择商品后操作");
      }
    },
    handleDelete: function (id) {
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        httpAction(this.url.delete, this.selectedRowKeys, "post").then(
          (res) => {
            if (res.code == 200) {
              //重新计算分页问题
              this.reCalculatePage(1);
              this.$message.success("删除成功");
              this.onClearSelected();
              this.loadData();
            } else {
              this.$message.warning(res.msg);
            }
          }
        );
      } else {
        this.$message.warning("请选择商品后删除");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
